// tslint:disable:max-line-length
import React from 'react'
import SvgIcon, { SvgIconProps } from '@material-ui/core/SvgIcon'

type InjectedProps = SvgIconProps

const QuizModeButtonIcon: React.SFC<InjectedProps> = (props) => {
  return (
    <SvgIcon viewBox="0 0 23 21" width="23" height="21" {...props}>
      <path fill="url(#quiz_mode_button_paint)" fillRule="evenodd" d="M15.67 7.9A7.4 7.4 0 0 0 8.36.44 7.4 7.4 0 0 0 1.04 7.9c0 1.2.28 2.37.82 3.43l-1.7 4.34a.48.48 0 0 0 .1.5.46.46 0 0 0 .5.11L5 14.55c1.03.55 2.19.84 3.36.84a7.4 7.4 0 0 0 7.31-7.48z" clipRule="evenodd"/>
      <path fill="#27354F" d="M7.8 9.2h1v-.42c0-.5.5-.75.84-1.06.41-.33.8-.75.8-1.49 0-1.07-.71-1.74-1.91-1.74-1.04 0-2.05.52-2.05 1.66v.4l1.01-.01v-.37c0-.57.54-.77.97-.77.52 0 .87.4.87.9 0 .64-.64 1-1.04 1.4-.32.31-.49.6-.49 1.07v.42zM7.7 11h1.18V9.66H7.7V11z" opacity=".27"/>
      <path fill="#9D9FA4" fillRule="evenodd" d="M22.04 19.42l-1.7-4.34a7.5 7.5 0 0 0-3.5-10.25.45.45 0 0 0-.5.08.48.48 0 0 0-.13.5 8.4 8.4 0 0 1-7.09 10.88.46.46 0 0 0-.39.3.48.48 0 0 0 .12.5 7.18 7.18 0 0 0 8.35 1.2l4.24 1.74a.45.45 0 0 0 .5-.1.48.48 0 0 0 .1-.5z" clipRule="evenodd"/>
      <defs>
        <linearGradient id="quiz_mode_button_paint" x1="5.08" x2="-7.99" y1="-6.08" y2="9.53" gradientUnits="userSpaceOnUse">
          <stop stopColor="#1FEEB4"/>
          <stop offset="1" stopColor="#20F796"/>
        </linearGradient>
      </defs>
    </SvgIcon>
  )
}

export default QuizModeButtonIcon
